import { Component, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IChangeCustomer, ICustomerSuggestion, IUserAccount, UserAccount, IState, ICountry, INewUserBody, IUser, Customer, IUpdateUserBody, IUpdateUserAccessToScreensBody } from '../../../core/models';
import { CustomerService } from '../../../core/services/customer.service';
import { ManageCompanyService } from '../../../core/services/manage-company.service';
import { Info } from '../../../core/common';
import { MasterDataService } from '../../../core/services/master-data.service';
import { UserService } from '../../../core/services/user.service';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { NotifyType } from '../../../core/enums/NotifyType';
import { CartService } from '../../../core/services/cart.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from '../../../core/services/helper.service';
import { error } from '@angular/compiler/src/util';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-manage-account',
  templateUrl: './manage-account.component.html',
  styleUrls: ['./manage-account.component.scss']
})
export class ManageAccountComponent implements OnInit {

  manageAccountGridView: GridDataResult;
  addNewUserForm: FormGroup;
  editUserForm: FormGroup;

  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public saveInProcess: boolean;
  public infoMessage: Info = new Info();
  public savedUserName: string = "";
  public customerCurrencyCode: string = "";
  currentCustomer: Customer;
  selectedCustomer: string;
  addedBy: string;
  //#region constructor INIT
  constructor(private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private manageCompanyService: ManageCompanyService,
    private masterDataService: MasterDataService,
    private userService: UserService,
    private appNotifyService: AppNotifyService,
    private router: Router,
    private route: ActivatedRoute,
    private cartService: CartService, private helperService: HelperService) { }

  ngOnInit() {

    const user = this.userService.readUserObject
    this.currentCustomer = new Customer();
    this.currentCustomer.customerNumber = +user.customerNumber;
    this.currentCustomer.customerName = user.customerName;
    this.customerCurrencyCode = user.currencyCode;
    this.addedBy = user.userId;
    //this.currentCustomer.addressLine1 = user.CustAddressLine1;

    this.initForm();
    this.initData();
    this.initAccess();
    this.getAllCustomers();
  }
  initText() { }
  isCSR: boolean = false;
  isSuperAdmin: boolean = false;
  isCustomerAdmin: boolean = false;
  isMultiCustomerAccount: boolean = false;
  initAccess() {
    this.isCSR = this.userService.isCSR();
    this.isSuperAdmin = this.userService.isSuperAdmin();
    this.isMultiCustomerAccount = this.userService.isMultiCustomerAccount();
  }
  initData() {
    this.loadUserGrid();
    this.masterDataService.GetCountries()
      .pipe(tap((countries: ICountry[]) => {
        this.masterDataService.countries = countries as ICountry[];
      })).subscribe((countries: ICountry[]) => {
        this.newUserDialog.countries = countries as ICountry[];
      });
    this.bindlanguageData();
  }
  public getAllLanguages: any;
  bindlanguageData() {
    this.getAllLanguages = [{ userLanguage: 'eng' }, { userLanguage: 'fre' }];
  }
  initForm() {
    this.addNewUserForm = this.formBuilder.group({
      userName: new FormControl(""),
      firstName: new FormControl(""),
      lastName: new FormControl(""),
      phoneNumber: new FormControl(""),
      email: new FormControl(""),
      confirmEmail: new FormControl(""),
      userLanguage: new FormControl("")
      //companyName: new FormControl(""),
      //companyAccNumber: new FormControl(""),
      //billingAddressOne: new FormControl(""),
      //billingAddressTwo: new FormControl(""),
      //city: new FormControl(""),
      //county: new FormControl(""),
      //state: new FormControl(),
      //country: new FormControl(),
      //zipCode: new FormControl(),
    })
    this.editUserForm = this.formBuilder.group({
      userId: new FormControl(""),
      userName: new FormControl(""),
      userLanguage: new FormControl(""),
      firstName: new FormControl(""),
      lastName: new FormControl(""),
      email: new FormControl(""),
      password: new FormControl(""),
      isInvoiceInquiry: new FormControl(""),
      isAccountSummary: new FormControl(""),
      isManageAddress: new FormControl(""),
      canPlaceOrder: new FormControl("")
    })
  }
  //#endregion

  canUpdateUser() {
    if (this.isSuperAdmin || this.isCustomerAdmin) return true;
    return false;
  }

  //#region Member Variables & getters & Setters
  //get selectedCustomer() {
  //  return this.manageCompanyService.selectedCustomer
  //}
  //#endregion 
  //#region customer autocomplete
  public showSuggestionBox: boolean;
  public filteredCustomerItems: IChangeCustomer[];
  public currentInputValueInItemSearch: string;
  public customerSearchLoading: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  splitText(eachItem: string) {
    if (this.currentInputValueInItemSearch.length === 1) {
      return eachItem.split('');
    }
    const regexString: string =
      this.currentInputValueInItemSearch +
      '|[^' +
      this.currentInputValueInItemSearch +
      ']|[0-9]|[a-z]';
    const regexConstructor: RegExp = new RegExp(regexString, 'gi');
    return eachItem.match(regexConstructor);
  }

  handleCustomerFilter(searchQuery: string) {
    const searchString = searchQuery;
    if (searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.showSuggestionBox = false;
      this.customerSearchLoading.next(true);
      this.currentInputValueInItemSearch = searchQuery;
      this.customerService.getSuggestion(searchString)
        .subscribe((data: ICustomerSuggestion[]) => {
          this.filteredCustomerItems = data;
          this.customerSearchLoading.next(false);
          this.showSuggestionBox = true;
        });
    } else {
      this.showSuggestionBox = false;
      this.customerService.searchCustomer.searchQuery = '';
      this.customerService.searchCustomer.customerNumber = '';
    }
  }
  onCloseCustomerChange(event) {
    this.filteredCustomerItems = this.customerDropdownData;
  }
  customerDropdownData: ICustomerSuggestion[];
  public getAllCustomers() {
    this.customerService.getSuggestion('').subscribe(response => {
      this.customerDropdownData = response;
      this.filteredCustomerItems = this.customerDropdownData;
    });
  }
  protected customerChangeSelected(event) {
    this.selectedCustomer = event.customerNameToDisplay;
  }
  updateCustomer() {
    //update customer details in localstorage
    console.log(this.selectedCustomer);
    const cust = (this.filteredCustomerItems as ICustomerSuggestion[]).find(x => x.fullCustomer === this.selectedCustomer);
    if (cust) {
      this.currentCustomer.customerNumber = +cust.customerNumber;
      this.currentCustomer.customerName = cust.customerName;
      this.customerCurrencyCode = cust.currencyCode;
      //add rest of the propertis here
      //load new set of user
      this.loadUserGrid();
    }

  }
  //#endregion
  //#region Grid data binding
  private loadUserGrid(): void {
    this.gridSettings.gridLoading = true;
    this.manageCompanyService.getUsersByCustomer(this.currentCustomer.customerNumber.toString()).subscribe((accountUser) => {
      //console.log(accountUser);
      this.bindUserGrid();
      this.gridSettings.gridLoading = false;
    });
  }
  //#endregion

  //#region label declaration
  protected manageAccountsGridColumnLbl = {
    userId: 'User Id',
    firstName: 'First Name',
    userLanguage: 'Language',
    lastName: 'Last Name',
    email: 'Email',
    phoneNumber: 'PhoneNumber',
    invoiceInquiry: 'Invoice Inquiry',
    hasAchPayment: 'ACH Payment',
    accountSummary: 'Account Summary',
    manageAddress: 'Manage Addresses',
    placeOrder: 'Can Place Orders',
    manageUsersLbl: 'Manage Users',
    lastLogin: 'Last Login',
    dateAdded: 'Date Added',
  };
  //#endregion
  //#region pagination, sorting,filtering for manage accounts grid
  protected gridSettings = {
    gridLoading: false
  };
  public accountGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'userId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  private bindUserGrid(): void {
    const data = this.manageCompanyService.accountUsers;
    this.manageAccountGridView = process(data, this.accountGridstate);
  }

  protected manageAccountGridSortChange(sort: SortDescriptor[]): void {
    this.accountGridstate.sort = sort;
    this.bindUserGrid();
  }
  protected manageAccountGridPageChange({ skip, take }: PageChangeEvent): void {
    this.accountGridstate.skip = skip;
    this.accountGridstate.take = take;
    this.bindUserGrid();
  }

  public manageAccountDataStateChange(state: DataStateChangeEvent): void {
    this.accountGridstate = state;
    this.bindUserGrid();
  }
  //#endregion
  //#region grid switch change events
  gridSwitchChange(user: IUser) {
    debugger;
    const body = {
      canPlaceOrder: user.canPlaceOrder,
      hasAccountSummary: user.hasAccountSummary,
      hasInvoiceInquiry: user.hasInvoiceInquiry,
      hasManageAddress: user.hasManageAddress,
      isActive: user.isActive,
      isInAdminRole: user.isInAdminRole,
      isInvoicePayment: user.isInvoicePayment,
      userId: user.userId
    };

    this.manageCompanyService.updateUserAccessToScreens(body).subscribe((response) => {
      if (response) {
        this.appNotifyService.notify(NotifyType.SUCCESS, "User has been  updated successfully");
        this.bindUserGrid();
      }
    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, "Sorry! an Error Occured!.Please refresh the page and try again");
    });
  }

  //#endregion
  //#region new user popup

  checkUserNameExist() {
    var userName = this.addNewUserForm.controls.userName.value;
    if (!userName) return;
    if (userName.toString().indexOf(" ") > -1) {
      this.newUserDialog.showUserNameIcon = true;
      this.newUserDialog.isUserNameValid = false;
      this.newUserDialog.userNameErrorTitle = "Space is not allowed in Username";
      return;
    }
    this.newUserDialog.showUserNameIcon = false;
    this.newUserDialog.userNameProcessing = false;
    this.newUserDialog.isUserNameValid = false;
    this.newUserDialog.isEmptyUserName = false;
    this.newUserDialog.userNameProcessing = true;
    this.userService.isUserNameAvailable(userName).subscribe((response: any) => {
      this.newUserDialog.userNameProcessing = false;
      if (!response.isError && response.data) {
        this.newUserDialog.showUserNameIcon = false;
        this.newUserDialog.isUserNameValid = true;

      }
      else {
        this.newUserDialog.showUserNameIcon = true;
        this.newUserDialog.isUserNameValid = false;
        this.newUserDialog.userNameErrorTitle = "Username is not available";
      }

    });
  }
  checkUserNameExistInUpdate() {
    this.editUserDialog.showUserNameIcon = false;
    this.editUserDialog.userNameProcessing = false;
    this.editUserDialog.isUserNameValid = false;
    const userName = this.editUserForm.controls.userName.value;
    if (userName) {
      if (this.savedUserName == userName) {
        this.editUserDialog.isUserNameValid = true;
        return;
      }
      this.editUserDialog.isEmptyUserName = false;
      this.editUserDialog.userNameProcessing = true;
      const body = {
        userName: userName
      }
      this.userService.isUserNameAvailable(body).subscribe((response: any) => {
        this.editUserDialog.userNameProcessing = false;
        if (response) {
          this.editUserDialog.showUserNameIcon = true;
          this.editUserDialog.isUserNameValid = false;
        }
        else {
          this.editUserDialog.showUserNameIcon = false;
          this.editUserDialog.isUserNameValid = true;

        }
      })
    }
  }

  isSubmitted: boolean;
  protected newUserDialog = {
    opened: false,
    isSubmitted: false,
    userIdLabel: "User Name",
    firstNamelabel: "First Name",
    userLanguageLabel: "Select Language",
    lastNameLabel: "Last Name",
    emailLabel: "Email",
    confirmEmailLabel: "Confirm Email",
    invalidEmail: "Email address is invalid",
    confirmEmailMatch: "Email and Confirm Email must be match.",
    phoneNumberLabel: "Phone Number",
    companyNameLabel: "Company Name",
    companyAccNumberLabel: "Company Account Number",

    billingAddress1: "Billing Address 1",
    billingAddress2: "Billing Address 2",
    userNameErrorTitle: "Username is not available",
    cityLabel: "City",
    countyLabel: "County",
    stateLabel: "State",
    countryLabel: "Country",
    zipCodeLabel: "Zip Code",
    states: [] as IState[],
    countries: [] as ICountry[],
    isEmptyUserName: false,
    isInvalidUserName: false,
    isInvalidFirstName: false,
    isInvalidLastName: false,
    isInvalidPhoneNumber: false,
    isInvalidPhoneNumberMessage: false,
    isInvalidEmail: false,
    isInvalidConfirmEmail: false,
    isEmailNotMatched: false,
    isInvalidCompanyName: false,
    isInvalidCompanyAccNumber: false,
    isInvalidBillingAddress1: false,
    isInvalidBillingAddress2: false,
    isInvalidCity: false,
    isInvalidBillingCity: false,
    isInvalidState: false,
    isInvalidCountry: false,
    isInvalidZipCode: false,
    isValidForm: this.validateNewUserForm(),
    showUserNameIcon: false,
    userNameProcessing: false,
    isUserNameValid: false,
    isEmailFormatInValid: false,
    isEmptyLanguage: false,
  };


  emailLeave() {
    const controls = this.addNewUserForm.controls;
    if (controls.email.value) {
      const res = this.helperService.isEmailFormatValid(controls.email.value);
      if (!res) {
        this.newUserDialog.isEmailFormatInValid = true;
        this.newUserDialog.isInvalidEmail = true;

      } else {
        this.newUserDialog.isEmailFormatInValid = false;
        this.newUserDialog.isInvalidEmail = false;
      }

    } else {
      this.newUserDialog.isEmailFormatInValid = false;
      if (this.newUserDialog.isSubmitted) {
        this.newUserDialog.isInvalidEmail = true;
      } else {
        this.newUserDialog.isInvalidEmail = false;
      }
    }
  }
  confirmEmailLeave() {
    const controls = this.addNewUserForm.controls;
    if (controls.confirmEmail.value) {
      if (controls.email.value) {
        if (controls.confirmEmail.value.toString().toLowerCase() != controls.email.value.toString().toLowerCase()) {
          this.newUserDialog.isInvalidConfirmEmail = true;
          this.newUserDialog.isEmailNotMatched = true;
        }
        else {
          this.newUserDialog.isInvalidConfirmEmail = false;
          this.newUserDialog.isEmailNotMatched = false;
        }
      }
    } else {
      if (this.newUserDialog.isSubmitted) {
        this.newUserDialog.isInvalidConfirmEmail = true;
        this.newUserDialog.isEmailNotMatched = false;
      }
    }
  }
  protected validateNewUserForm(): boolean {
    debugger;
    let isValid = true;
    if (!this.newUserDialog) {
      return;
    }
    const controls = this.addNewUserForm.controls;
    if (this.newUserDialog.isSubmitted) {
      if (controls.userName.value) {
        this.newUserDialog.isInvalidUserName = false;
        if (controls.userName.value.toString().indexOf(" ") > -1) {
          this.newUserDialog.isInvalidUserName = true;
          isValid = false;
        }
      } else {
        this.newUserDialog.isEmptyUserName = true;
        this.newUserDialog.isInvalidUserName = true;
        isValid = false;
      }
      if (controls.firstName.value) {
        this.newUserDialog.isInvalidFirstName = false;
      } else {
        this.newUserDialog.isInvalidFirstName = true;
        isValid = false;
      }
      if (controls.userLanguage.value) {
        this.newUserDialog.isEmptyLanguage = false;
      } else {
        this.newUserDialog.isEmptyLanguage = true;
        isValid = false;
      }
      if (controls.lastName.value) {
        this.newUserDialog.isInvalidLastName = false;
      } else {
        this.newUserDialog.isInvalidLastName = true;
        isValid = false;
      }
      if (controls.email.value) {
        const res = this.helperService.isEmailFormatValid(controls.email.value);
        if (!res) {
          this.newUserDialog.isEmailFormatInValid = true;
          this.newUserDialog.isInvalidEmail = true;
          isValid = false;
        } else {
          this.newUserDialog.isEmailFormatInValid = false;
          this.newUserDialog.isInvalidEmail = false;
        }

      } else {
        this.newUserDialog.isInvalidEmail = true;
        isValid = false;
      }
      if (controls.confirmEmail.value) {
        if (controls.confirmEmail.value.toString().toLowerCase() != controls.email.value.toString().toLowerCase()) {
          this.newUserDialog.isInvalidConfirmEmail = true;
          this.newUserDialog.isEmailNotMatched = true;
          isValid = false;
        }
        else {
          this.newUserDialog.isInvalidConfirmEmail = false;
          this.newUserDialog.isEmailNotMatched = false;
        }

      } else {
        this.newUserDialog.isInvalidConfirmEmail = true;
        this.newUserDialog.isEmailNotMatched = false;
        isValid = false;
      }
     
      if (controls.phoneNumber.value) {
        this.newUserDialog.isInvalidPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.newUserDialog.isInvalidPhoneNumber = true;
          this.newUserDialog.isInvalidPhoneNumberMessage = true;
          isValid = false;
        } else {
          this.newUserDialog.isInvalidPhoneNumber = false;
          this.newUserDialog.isInvalidPhoneNumberMessage = false;
        }
      } else {
        this.newUserDialog.isInvalidPhoneNumber = true;
        isValid = false;
      }
      //if (controls.companyName.value) {
      //  this.newUserDialog.isInvalidCompanyName = false;
      //} else {
      //  this.newUserDialog.isInvalidCompanyName = true;
      //  isValid = false;
      //}
      //if (controls.companyAccNumber.value) {
      //  this.newUserDialog.isInvalidCompanyAccNumber = false;
      //} else {
      //  this.newUserDialog.isInvalidCompanyAccNumber = true;
      //  isValid = false;
      //}

      //if (controls.billingAddressOne.value) {
      //  this.newUserDialog.isInvalidBillingAddress1 = false;
      //} else {
      //  this.newUserDialog.isInvalidBillingAddress1 = true;
      //  isValid = false;
      //}
      //if (controls.billingAddressTwo.value) {
      //  this.newUserDialog.isInvalidBillingAddress2 = false;
      //} else {
      //  this.newUserDialog.isInvalidBillingAddress2 = true;
      //  isValid = false;
      //}
      //if (controls.city.value) {
      //  this.newUserDialog.isInvalidCity = false;
      //} else {
      //  this.newUserDialog.isInvalidCity = true;
      //  isValid = false;
      //}
      //if (controls.zipCode.value) {
      //  this.newUserDialog.isInvalidZipCode = false;
      //} else {
      //  this.newUserDialog.isInvalidZipCode = true;
      //  isValid = false;
      //}

      //if (controls.state.value) {
      //  this.newUserDialog.isInvalidState = false;
      //} else {
      //  this.newUserDialog.isInvalidState = true;
      //  isValid = false;
      //}
      //if (controls.country.value) {
      //  this.newUserDialog.isInvalidCountry = false;
      //} else {
      //  this.newUserDialog.isInvalidCountry = true;
      //  isValid = false;

      //}
    }
    return isValid;
  }

  registerUser() {
    this.newUserDialog.isSubmitted = true;
    if (!this.validateNewUserForm()) {
      return;
    }
    if (this.newUserDialog.isUserNameValid == true) {
      this.inProgressMessage = true;
      this.saveInProcess = true;
      this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;

      const controls = this.addNewUserForm.controls;
      const body = {
        userName: controls.userName.value,//unique validation
        userLanguage: controls.userLanguage.value,
        userFirstName: controls.firstName.value,
        userLastName: controls.lastName.value,
        customerNumber: this.currentCustomer.customerNumber.toString(),
        customerName: this.currentCustomer.customerName.toString(),
        phoneNumber: controls.phoneNumber.value ? controls.phoneNumber.value.toString() : 0,
        email: controls.email.value,
        addedBy: this.addedBy
      }
      this.manageCompanyService.addNewUser(body).subscribe((response: any) => {
        this.infoMessage.genericInProgress = "";
        this.saveInProcess = false;
        if (response) {
          this.successMessage = true;
          this.infoMessage.genericSuccess = this.infoMessage.successMessage;

        } else {
          this.infoMessage.genericError = this.infoMessage.errorMessage;

        }
        this.addNewUserForm.reset();
        this.newUserDialog.showUserNameIcon = false;
        this.newUserDialog.userNameProcessing = false;
        this.newUserDialog.isUserNameValid = false;
        this.loadUserGrid();
      }, error => {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
        this.saveInProcess = false;
      })
    }
  }
  resetUserForm() {
    this.addNewUserForm.reset();
    this.newUserDialog.showUserNameIcon = false;
    this.newUserDialog.userNameProcessing = false;
    this.newUserDialog.isUserNameValid = false;
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.newUserDialog.isEmptyUserName = false;
    this.newUserDialog.isInvalidFirstName = false;
    this.newUserDialog.isInvalidLastName = false;
    this.newUserDialog.isInvalidEmail = false;
    this.newUserDialog.isEmailFormatInValid = false;
    this.newUserDialog.isInvalidConfirmEmail = false;
    this.newUserDialog.isEmailNotMatched = false;
    this.newUserDialog.isInvalidCompanyName = false;
    this.newUserDialog.isInvalidCompanyAccNumber = false;
    this.newUserDialog.isInvalidBillingAddress1 = false;
    this.newUserDialog.isInvalidBillingAddress2 = false;
    this.newUserDialog.isInvalidCity = false;
    this.newUserDialog.isInvalidState = false;
    this.newUserDialog.isInvalidCountry = false;
    this.newUserDialog.isInvalidZipCode = false;
    this.newUserDialog.isInvalidPhoneNumber = false;
    this.newUserDialog.isInvalidPhoneNumberMessage = false;
    this.newUserDialog.isSubmitted = false;
    this.newUserDialog.isEmptyLanguage = false;
  }
  toggleNewUserDialog() {
    this.newUserDialog.opened = !this.newUserDialog.opened
    this.resetUserForm();
  }

  public countySelectionChange(event) {
    console.log(event);
    if (event) {
      this.newUserDialog.states = event.states;
    }
    this.validateNewUserForm();
  }
  stateSelectionChange() {
    this.validateNewUserForm();

  }
  //#endregion

  //#edit user popup
  protected editUserDialog = {
    opened: false,
    isSubmitted: false,
    userNameLabel: "User Name",
    firstNamelabel: "First Name",
    lastNameLabel: "Last Name",
    emailLabel: "User Email",
    passwordLabel: "Password",
    isEmptyUserName: false,
    isInvalidFirstName: false,
    isInvalidLastName: false,
    isInvalidEmail: false,
    isInvalidPassword: false,
    isValidForm: this.validateEditUserForm(),
    showUserNameIcon: false,
    userNameProcessing: false,
    isUserNameValid: false,
    isEmailFormatInValid: false,
  };
  protected resetPwdUserDialog = {
    opened: false,
    title: "Reset Password",
    msg: "Do you want reset password of the user",
    userId: "",
    email: "",
    userName: ""
  };
  editUserEmailLeave() {
    const controls = this.editUserForm.controls;
    if (controls.email.value) {
      const res = this.helperService.isEmailFormatValid(controls.email.value);
      if (!res) {
        this.editUserDialog.isEmailFormatInValid = true;
        this.editUserDialog.isInvalidEmail = true;

      } else {
        this.editUserDialog.isEmailFormatInValid = false;
        this.editUserDialog.isInvalidEmail = true;
      }

    } else {
      this.editUserDialog.isEmailFormatInValid = false;
      if (this.editUserDialog.isSubmitted) {
        this.editUserDialog.isInvalidEmail = true;

      } else {
        this.editUserDialog.isInvalidEmail = false;

      }
    }
  }
  protected validateEditUserForm(): boolean {
    let isValid = true;
    if (!this.editUserDialog) {
      return;
    }
    const controls = this.editUserForm.controls;
    if (this.editUserDialog.isSubmitted) {
      if (controls.userName.value) {
        this.editUserDialog.isEmptyUserName = false;
      } else {
        this.editUserDialog.isEmptyUserName = true;
        isValid = false;
      }
      if (controls.firstName.value) {
        this.editUserDialog.isInvalidFirstName = false;
      } else {
        this.editUserDialog.isInvalidFirstName = true;
        isValid = false;
      }
      if (controls.lastName.value) {
        this.editUserDialog.isInvalidLastName = false;
      } else {
        this.editUserDialog.isInvalidLastName = true;
        isValid = false;
      }
      if (controls.email.value) {
        this.editUserDialog.isInvalidEmail = false;
      } else {
        this.editUserDialog.isInvalidEmail = true;
        isValid = false;
      }
      if (controls.email.value) {
        const res = this.helperService.isEmailFormatValid(controls.email.value);
        if (!res) {
          this.editUserDialog.isEmailFormatInValid = true;
          this.editUserDialog.isInvalidEmail = true;
          isValid = false;
        } else {
          this.editUserDialog.isEmailFormatInValid = false;
          this.editUserDialog.isInvalidEmail = false;
        }

      } else {
        this.editUserDialog.isInvalidEmail = true;
        isValid = false;
      }
      //if (controls.password.value) {
      //  this.editUserDialog.isInvalidPassword = false;
      //} else {
      //  this.editUserDialog.isInvalidPassword = true;
      //  isValid = false;
      //}

    }
    return isValid;
  }
  toggleEditUserDialog(data: IUser) {
    this.editUserDialog.opened = !this.editUserDialog.opened
    if (this.editUserDialog.opened) {
      this.infoMessage = new Info();
      this.saveInProcess = false;
      //this.editUserForm.controls.userId.setValue(data.userId);
      this.editUserForm.controls.userName.setValue(data.userName);
      this.editUserForm.controls.firstName.setValue(data.userFirstName);
      this.editUserForm.controls.lastName.setValue(data.userLastName);
      this.editUserForm.controls.email.setValue(data.email);
      this.savedUserName = data.userName;
      //this.editUserForm.controls.password.setValue(data.password);
      //this.editUserForm.controls.isInvoiceInquiry.setValue(data.isInvoiceInquiry);
      //this.editUserForm.controls.isAccountSummary.setValue(data.isAccountSummary);
      //this.editUserForm.controls.isManageAddress.setValue(data.isManageAddress);
      //this.editUserForm.controls.canPlaceOrder.setValue(data.canPlaceOrder);
    } else {
      this.resetUpdateUserForm();
    }


  }
  toggleResetPwdUserDialog(data: IUser) {
    this.resetPwdUserDialog.opened = !this.resetPwdUserDialog.opened
    if (this.resetPwdUserDialog.opened) {
      this.resetPwdUserDialog.msg = "Do you want to reset password of " + data.userName;
      this.resetPwdUserDialog.userId = data.userId;
      this.resetPwdUserDialog.userName = data.userName,
        this.resetPwdUserDialog.email = data.email
    } else {
      this.resetPwdUserDialog.userId = "";
      this.resetPwdUserDialog.userName = "",
        this.resetPwdUserDialog.email = ""
    }
  }

  resetUpdateUserForm() {
    this.editUserForm.reset();
    this.savedUserName = "";
    this.editUserDialog.isEmptyUserName = false;
    this.editUserDialog.isInvalidFirstName = false;
    this.editUserDialog.isInvalidLastName = false;
    this.editUserDialog.isInvalidEmail = false;
    this.editUserDialog.isInvalidPassword = false;
    this.editUserDialog.isSubmitted = false;
    this.editUserDialog.showUserNameIcon = false;
    this.editUserDialog.userNameProcessing = false;
    this.editUserDialog.isUserNameValid = false;
    this.editUserDialog.isEmailFormatInValid = false;
    this.infoMessage = new Info();
    this.saveInProcess = false;

  }
  resetPwd() {
    debugger;
    if (this.resetPwdUserDialog.opened) {
      const body = {
        userId: this.resetPwdUserDialog.userId,
        email: this.resetPwdUserDialog.email,
        userName: this.resetPwdUserDialog.userName,
      }
      this.manageCompanyService.resetUserPassword(body).subscribe((response: any) => {
        this.infoMessage.genericInProgress = "";
        this.saveInProcess = false;
        console.log(response);
        this.resetPwdUserDialog.opened = false;
        this.resetPwdUserDialog.userId = "";
        this.resetPwdUserDialog.email = "";
        this.resetPwdUserDialog.userName = "";
        if (response) {
          this.successMessage = true;
          this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        } else {
          this.infoMessage.genericError = this.infoMessage.errorMessage;
        }
      }, error => {
          this.resetPwdUserDialog.userId = "";
          this.resetPwdUserDialog.opened = false;
          this.resetPwdUserDialog.email = "";
          this.resetPwdUserDialog.userName = "";
        this.saveInProcess = false;
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      });
    }
  }
  updateUser() {
    this.editUserDialog.isSubmitted = true;
    //Need to check validation here
    if (!this.validateEditUserForm()) {
      return;
    }
    // this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    const body: IUpdateUserBody = {
      userName: this.editUserForm.value.userName,
      userFirstName: this.editUserForm.value.firstName,
      userLastName: this.editUserForm.value.lastName,
      email: this.editUserForm.value.email,
    }
    this.manageCompanyService.updateUserAccount(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      console.log(response)
      if (response) {
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        //this.bindUserGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
      this.loadUserGrid();
      //this.resetUpdateUserForm();
    }, error => {
      this.saveInProcess = false;
      this.infoMessage.genericError = this.infoMessage.errorMessage;
    });
  }

  formateDates(data) {
    return data ? formatDate(data, 'MM/dd/yyyy hh:mm a', 'en') : data;
  }
  keyDownHandler(event) {
    if (event.keyCode == 32) {
      return false;
    }
  }
  //#endregion
}
